import * as React from "react";
import { Route, Routes } from "react-router-dom";

import { Page } from "lib/page";

import { EditSettingsPage } from "./editSettings";

export const SettingsIndex: React.FC = () => {
  return (
    <Routes>
      <Route path="*" element={<Page element={<EditSettingsPage />} />} />
    </Routes>
  );
};
